import { initializeApp } from "firebase/app";
import Cookies from 'js-cookie';
import { getAuth } from "firebase/auth";
import { getAnalytics } from 'firebase/analytics';

const url = Cookies.get('url');
const apiUrl = `https://${url}`;

// local
// const firebaseConfig = {
//     apiKey: "AIzaSyAdsGGBh0V4-mKACEXW9CqPVQkckEBbFFs",
//     authDomain: "analytics-f2b1e.firebaseapp.com",
//     projectId: "analytics-f2b1e",
//     storageBucket: "analytics-f2b1e.firebasestorage.app",
//     messagingSenderId: "646913850653",
//     appId: "1:646913850653:web:8422beaa5bd1af1c12f5f4",
//     measurementId: "G-9G2L8WR3D4"
// };

const firebaseConfig = {
  apiKey: "AIzaSyDLyScWeQO32uCgeIAT716MFQh38YZM14M",
  authDomain: "chulltv.firebaseapp.com",
  projectId: "chulltv",
  storageBucket: "chulltv.firebasestorage.app",
  messagingSenderId: "188395223241",
  appId: "1:188395223241:web:5ed2d6200253d2ee62b518",
  measurementId: "G-EP4Y0DDH33"
};


const app = initializeApp(firebaseConfig);
// const app = (apiUrl === "https://mahuaplay.ottsnap.in" ? initializeApp(mahua) : initializeApp(firebaseConfig));
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
// export default app;